import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-modal';
import DOMPurify from 'dompurify';
import { Button } from 'react-bootstrap/lib';
import './PreviewButtonModal.scss';

class PreviewButtonModal extends Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: true,
    };
  }

  saveModal = () => {
    this.props.saveModal();
  };

  cancelModal = () => {
    this.setState({ modalIsOpen: false });
    this.props.cancelModal();
  };

  render() {
    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        onRequestClose={this.cancelModal}
        contentLabel="Widget Config Modal"
        style={{
          content: {
            width: '50%',
            margin: '0 auto',
          },
        }}
      >
        <h3 className="preview-title">
          Preview <strong>{this.props.activeTab.title}</strong>
        </h3>
        <div
          className="css-container"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(this.props.css),
          }}
        />
        <div
          id="previewContainer"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(this.props.html),
          }}
        />
        <div className="action-container">
          <Button bsClass="btn" onClick={this.cancelModal}>
            Cancel
          </Button>
          <Button
            bsClass="btn btn-primary float-right"
            onClick={this.saveModal}
          >
            Save Configuration
          </Button>
        </div>
      </Modal>
    );
  }
}

PreviewButtonModal.propTypes = {
  saveModal: PropTypes.func,
  cancelModal: PropTypes.func,
  activeTab: PropTypes.object,
  css: PropTypes.string,
  html: PropTypes.string,
};

export default PreviewButtonModal;
